import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelBoardingPassIssueHpbpRequest,
  failBoardingPassIssueHpbp,
  setBoardingPassIssueHpbp,
  setBoardingPassIssueHpbpFromApi,
  updateBoardingPassIssueHpbp,
  updateBoardingPassIssueHpbpFromApi,
} from './boarding-pass-issue-hpbp.actions';

/**
 * Service to handle async BoardingPassIssueHpbp actions
 */
@Injectable()
export class BoardingPassIssueHpbpEffect {
  /**
   * Set the state with the reply content, dispatch failBoardingPassIssueHpbp if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setBoardingPassIssueHpbpFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setBoardingPassIssueHpbp({ model: reply, requestId: action.requestId }),
        (error, action) => of(failBoardingPassIssueHpbp({ error, requestId: action.requestId })),
        cancelBoardingPassIssueHpbpRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failBoardingPassIssueHpbp if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateBoardingPassIssueHpbpFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateBoardingPassIssueHpbp({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failBoardingPassIssueHpbp({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
